export default "__VITE_ASSET__81395480__"